import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { IoCloseOutline } from "react-icons/io5";

export default function EditEvent({ OnClose }) {
  const { chatData, refreshChatData, validateEcode } = useAuth();
  const [isVisible, setIsVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    event_venue: "",
    event_city: "",
    event_state: "",
    event_country: "",
    event_date: "",
    event_time: "",
    ticket_type: "",
    section: "",
    row: "",
    entry_info: "",
    seat_no: "",
    num_seats: "",
    ticket_price: "",
    lat: "",
    lon: "",
  });

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
    if (chatData) {
      setFormData({
        event_venue: chatData.event_venue || "",
        event_city: chatData.event_city || "",
        event_state: chatData.event_state || "",
        event_country: chatData.event_country || "",
        event_date: chatData.event_date || "",
        event_time: chatData.event_time || "",
        ticket_type: chatData.ticket_type || "",
        section: chatData.section || "",
        row: chatData.row || "",
        entry_info: chatData.entry_info || "",
        seat_no: chatData.seat_no || "",
        num_seats: chatData.num_seats || "",
        ticket_price: chatData.ticket_price || "",
        lat: chatData.lat || "",
        lon: chatData.lon || "",
        chat_id: chatData.chat_id,
      });
    }
  }, [chatData]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(OnClose, 300);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(
        "https://kracet.shop/mastapi/eventupdate.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(formData).toString(),
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("Event updated successfully!");
        refreshChatData();
        validateEcode();
        handleClose();
      } else {
        alert("Update failed: " + result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ height: "100%" }}
    >
      <div>
        <div className="mb-4" style={{ backgroundColor: "rgb(22, 19, 22)" }}>
          <div className="flex items-center justify-between w-full pt-2 pb-2 pl-4 pr-4">
            <div className="flex justify-start">
              <button className=" text-gray-200" onClick={handleClose}>
                <IoCloseOutline size={33} />
              </button>
            </div>
            <div className="mx-auto">
              <div className="flex items-center justify-center gap-1">
                <p className="text-md font-medium text-gray-200">Edit Event</p>
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 pb-6 h-[90vh] overflow-y-scroll scroll-smooth">
          <div className="border-y border-gray-900 py-2">
            <p className="font-bold text-md">
              Use the website below to get the accurate longitude and latitude
              for the map location
            </p>
            <p>https://www.gps-coordinates.net</p>
            <p className="font-bold text-md">
              on the website, input the venue name into the 'ADDRESS' search bar
              and click 'GET GPS CORDINATES'
            </p>
          </div>

          <div className="mt-4">
            <form onSubmit={handleSubmit}>
              {[
                { label: "Event Venue", name: "event_venue" },
                { label: "Event City", name: "event_city" },
                { label: "Event State", name: "event_state" },
                { label: "Event Country", name: "event_country" },
                { label: "Event Date", name: "event_date", type: "date" },
                { label: "Event Time", name: "event_time", type: "time" },
                { label: "Ticket Type", name: "ticket_type" },
                { label: "Section", name: "section" },
                { label: "Row", name: "row" },
                { label: "Entry Info", name: "entry_info" },
                { label: "Seat Num", name: "seat_no", type: "number" },
                {
                  label: "No. of Seats",
                  name: "num_seats",
                  type: "number",
                  min: 1,
                  max: 4,
                },
                { label: "Price", name: "ticket_price", type: "number" },
                { label: "Map latitude", name: "lat", type: "number" },
                { label: "Map longitude", name: "lon", type: "number" },
              ].map((field, index) => (
                <div key={index} className="mb-4">
                  <p className="text-lg font-semibold">{field.label}</p>
                  <input
                    type={field.type || "text"}
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                    className="w-full p-2 border border-black rounded"
                    min={field.min}
                    max={field.max}
                  />
                </div>
              ))}

              <div className="mt-4">
                <button
                  type="submit"
                  className="bg-blue-950 rounded-lg w-3/5 text-white px-4 py-2 flex items-center justify-center"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <svg
                      className="animate-spin h-5 w-5 mr-2 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                      ></path>
                    </svg>
                  ) : null}
                  {isSubmitting ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
